/**
 * Builds admin app URL with tenant and path.
 * Uses the new admin base URL injected at build time via webpack DefinePlugin.
 */
export function buildAdminUrl(tenant: number | string, path: string): string {
  return `${NEW_ADMIN_BASE_URL}/org/${tenant}${path}`;
}

/**
 * Builds a legacy admin (addax) URL with tenant and path. The legacy mapping
 * editors — conversion mapping in particular — are edited there while the
 * admin app's `new-admin-migration` flag is off (RGI-2511).
 */
export function buildLegacyAdminUrl(
  tenant: number | string,
  path: string
): string {
  return `${OLD_ADMIN_BASE_URL}/org/${tenant}${path}`;
}
